// extracted by mini-css-extract-plugin
export default {"banner":"boardbanner_banner__MS5x5"};